const state = { character: "", inventory: 1, stamina: 3 };

export default state;
